export default function Process() {
  const steps = [
    {
      number: '01',
      title: 'Consultation',
      description: 'We discuss your vision, needs, and budget to understand exactly what you want for your space.',
      icon: 'ri-discuss-line'
    },
    {
      number: '02',
      title: 'Material Selection',
      description: 'Choose from our premium selection of materials, colors, and finishes that match your style.',
      icon: 'ri-palette-line'
    },
    {
      number: '03',
      title: 'Digital Measurement',
      description: 'Our advanced digital technology ensures precise measurements for a perfect fit every time.',
      icon: 'ri-ruler-2-line'
    },
    {
      number: '04',
      title: 'Fabrication',
      description: 'Expert craftsmen fabricate your custom countertops with meticulous attention to detail.',
      icon: 'ri-tools-line'
    },
    {
      number: '05',
      title: 'Installation',
      description: 'Professional installation completed efficiently with minimal disruption to your daily routine.',
      icon: 'ri-hammer-line'
    }
  ];

  return (
    <section className="py-24 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Our <span className="text-amber-500">Process</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            From consultation to installation, we make it seamless
          </p>
        </div>

        {/* Process Steps */}
        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-1 bg-amber-600/20 transform -translate-y-1/2"></div>

          <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                {/* Step Card */}
                <div className="bg-gray-800 p-8 rounded-2xl hover:bg-gray-700 transition-all duration-300 h-full">
                  {/* Number Badge */}
                  <div className="w-16 h-16 bg-amber-600 rounded-full flex items-center justify-center text-2xl font-bold mb-6 mx-auto">
                    {step.number}
                  </div>
                  
                  {/* Icon */}
                  <div className="text-center mb-4">
                    <i className={`${step.icon} text-4xl text-amber-500`}></i>
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-bold text-center mb-3">
                    {step.title}
                  </h3>
                  <p className="text-gray-400 text-center text-sm leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <button 
            onClick={() => {
              const element = document.getElementById('contact-form');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-amber-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-amber-700 transition-all shadow-2xl hover:shadow-amber-600/50 whitespace-nowrap"
          >
            Start Your Project Today
          </button>
        </div>
      </div>
    </section>
  );
}